import React from 'react';

type BrandMarkProps = {
  className?: string;
  size?: 'default' | 'large';
};

export default function BrandMark({ className = '', size = 'default' }: BrandMarkProps) {
  return (
    <img
      src={`${process.env.PUBLIC_URL}/scoutly-logo.png`}
      alt=""
      className={['brand-mark', size === 'large' ? 'brand-mark-lg' : '', className].filter(Boolean).join(' ')}
      aria-hidden
    />
  );
}
